import React from 'react';
import './home.css';

function Home() {
  return (
    <div className="home">
      <div className="logo-container">
        <img src="logo_withText.svg" alt="Nexus API Logo" className="logo"/>
        <div className="status">Coming Soon</div>
      </div>
    </div>
  );
}

export default Home;
